import { EventManager } from '../services/event-manager.service';
import { HttpService } from '../services/http.service';
import { CalculatorService } from '../services/calculator.service';
import { ValidationService } from '../services/validation.service';
import { WpbbsaCalculatorService } from '../services/wpbbsa-calculator.service';
import { AnalyticsService } from '../services/analytics.service';
import { FormsService } from '../services/forms.service';
import { DataConsentService } from "../services/data-consent.service";
import { FormLocationService } from '../services/form-location.service';
import { FinanceCalculatorService } from '../services/finance-calculator.service';
import { SurveyExpiryInfoService } from '../services/survey-expiry-info.service';
var Base = /** @class */ (function () {
    function Base(element) {
        this.baseUrl = '';
        this.element = element;
        this.event = EventManager.Instance;
        this.http = HttpService.getInstance();
        this.calculatorService = CalculatorService.getInstance();
        this.validationService = ValidationService.getInstance();
        this.wpbbsaCalculatorService = WpbbsaCalculatorService.getInstance();
        this.analyticsService = AnalyticsService.getInstance();
        this.formsService = FormsService.getInstance();
        this.dataConsentService = DataConsentService.getInstance();
        this.formLocationService = FormLocationService.getInstance();
        this.financeCalculatorService = FinanceCalculatorService.getInstance();
        this.surveyExpiryInfoService = SurveyExpiryInfoService.getInstance();
        this.init();
        this.bindEvents();
    }
    return Base;
}());
export { Base };



//////////////////
// WEBPACK FOOTER
// ./components/base-component.ts
// module id = 1
// module chunks = 0